import React, {useContext} from "react";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import "./Greeting.scss";
import landingPerson from "../../assets/lottie/scientist.json";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";

import {illustration, greeting} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function Greeting() {
  const {isDark} = useContext(StyleContext);
  if (!greeting.displayGreeting) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">👋</span>
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
              I am an incoming Junior Professor of Psychological Metascience at the <a href="https://leibniz-psychology.org" target="_blank" rel="noopener noreferrer">Leibniz Institute for Psychology (ZPID)</a>. Currently, I am a Postdoc at the University of Bern, where I'm helping to validate <a href="https://regcheck.app" target="_blank" rel="noopener noreferrer">RegCheck</a>. My metaresearch examines how research methods and practices have been changing in psychology (especially social and personality psychology) over the replication crisis.
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />
                {greeting.resumeLink && (
                  <Button
                    text="My CV"
                    newTab={true}
                    href={greeting.resumeLink}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <img
              alt="Beth's profile picture"
              src={require("../../assets/images/BC_profile_pic.jpg")}
            />
        </div>
        </div>
      </div>
    </Fade>
  );
}
